import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_118: FaireProductEntity = {
  token: "legacy_prod_abbott-118",
  type: "product",
  name: "Beehive Honey Pot W Dauber-Wht",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/be76355b22f14c2940013bc4baa481ae7f4f845bb3de3bc8237002da88151655.jpeg",
  priceDollars: 22,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
